import useQuery from 'src/js/modules/common/hooks/use-query';
import { loadFontsData } from './load-fonts-data';

const defaultFontsData = [];

const useFontsData = () => {
  const query = useQuery({ queryKey: ['fonts-data'], queryFn: loadFontsData });
  const data = query.data ?? defaultFontsData;

  return {
    ...query,
    data,
  };
};

export default useFontsData;
